// Sort helpers shared by the Favorites page and the favorites grid page.
// Mirrors the Android app's WatchlistSorter (Name / Recently Watched / Date
// Added, plus a "Custom" mode after a manual reorder).

export const FAVORITES_SORT_OPTIONS = [
  { id: "name", label: "Name (A-Z)" },
  { id: "recently", label: "Recently Watched" },
  { id: "dateAdded", label: "Date Added" },
];

// Default direction applied when an option is first selected.
export const DEFAULT_DIRECTION = {
  name: "asc",
  recently: "desc",
  dateAdded: "desc",
  custom: "asc",
};

export const labelForSort = (option) => {
  if (option === "custom") return "Custom";

  const match = FAVORITES_SORT_OPTIONS.find((o) => o.id === option);

  return match?.label || "Name (A-Z)";
};

// Recency rank from local watch history. The list is appended in watch order
// (later index = more recently watched), so the index is the recency rank.
const getRecencyRank = () => {
  const rank = {};

  try {
    const raw = localStorage.getItem("webPlayer_recentlyWatchedProgress");

    if (raw) {
      JSON.parse(raw).forEach((item, index) => {
        if (item?.mediaId != null) rank[String(item.mediaId)] = index;
      });
    }
  } catch {
    // ignore malformed cache
  }

  return rank;
};

const nameOf = (item) => String(item?.name || item?.title || "").toLowerCase();

const dateAddedOf = (item) => {
  const d = item?.dateAdded;

  if (d == null) return 0;
  const t = typeof d === "number" ? d : Date.parse(d);

  return Number.isFinite(t) ? t : 0;
};

// Returns a sorted copy of items. "custom" returns the list unchanged (it's
// already in the saved sort_order from the API).
export const sortFavorites = (items, option, direction) => {
  const list = Array.isArray(items) ? [...items] : [];

  if (option === "custom") return list;

  const dir = direction === "asc" ? 1 : -1;

  if (option === "name") {
    list.sort((a, b) => nameOf(a).localeCompare(nameOf(b)) * dir);
  } else if (option === "dateAdded") {
    list.sort((a, b) => (dateAddedOf(a) - dateAddedOf(b)) * dir);
  } else if (option === "recently") {
    const rank = getRecencyRank();
    const rankOf = (item) => {
      const r = rank[String(item?.mediaId ?? item?.id)];

      return r == null ? -1 : r;
    };

    list.sort((a, b) => (rankOf(a) - rankOf(b)) * dir);
  }

  return list;
};
